import { GridPinnedColumnFields } from "@mui/x-data-grid-premium";

// Base default columns (always pinned)
const DEFAULT_RIGHT_BASE = ["numExceptions", "numAlerts", "numNotes", "contactInfo"];
export const DEFAULT_LEFT = ["homeSiteId"];

// Get default right columns based on feature flag
export const getDefaultRight = (showMilestoneProgress: boolean = false): string[] => {
  if (showMilestoneProgress) {
    // Insert milestoneProgress before contactInfo
    return ["numExceptions", "numAlerts", "numNotes", "milestoneProgress", "contactInfo"];
  }
  return DEFAULT_RIGHT_BASE;
};

// For backward compatibility - defaults to not showing milestone progress
export const DEFAULT_RIGHT = DEFAULT_RIGHT_BASE;

export const sanitizePinned = (
  p: GridPinnedColumnFields,
  showMilestoneProgress: boolean = false
): GridPinnedColumnFields => {
  const defaultRight = getDefaultRight(showMilestoneProgress);
  const right = Array.from(
    new Set([...(p.right ?? []).filter(c => !defaultRight.includes(c)), ...defaultRight])
  );
  const left = (p.left ?? []).filter(c => !defaultRight.includes(c));
  return { left, right };
};

export const defaultPinned = (showMilestoneProgress: boolean = false): GridPinnedColumnFields =>
  sanitizePinned({ left: DEFAULT_LEFT, right: [] }, showMilestoneProgress);

// Per-tab session id: survives route changes, resets on full reload/new tab.
export const getAppSessionId = (): string => {
  const g = globalThis as any;
  if (!g.__APP_SESSION_ID__) {
    const uuid =
      g?.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`;
    g.__APP_SESSION_ID__ = uuid;
  }
  return g.__APP_SESSION_ID__;
};

export const pinnedSessionKey = (page: string, viewName: string) =>
  `pinned:${page}:${viewName}:${getAppSessionId()}`;

// Which view is currently selected on a page (per-tab/per-session)
export const selectedViewSessionKey = (page: string) =>
  `selectedView:${page}:${getAppSessionId()}`;